import Layout from '@/pages/Layout.vue'


import Dashboard from '@/pages/Dashboard.vue'

import PendingApplications from '@/pages/PendingApplications.vue'
import PendingApplicationsView from '@/pages/PendingApplications/View.vue'
import PendingApplicationsDetail from '@/pages/PendingApplications/Detail.vue'

import OngoingApplications from '@/pages/OngoingApplications.vue'
import OngoingApplicationsView from '@/pages/OngoingApplications/View.vue'
import OngoingApplicationsDetail from '@/pages/OngoingApplications/Detail.vue'

import CompletedApplications from '@/pages/CompletedApplications.vue'
import CompletedApplicationsView from '@/pages/CompletedApplications/View.vue'

import Units from '@/pages/Units.vue'
import UnitsView from '@/pages/Units/View.vue'
import UnitsNew from '@/pages/Units/New.vue'
import UnitsEdit from '@/pages/Units/Edit.vue'

import Users from '@/pages/Users.vue'
import UsersView from '@/pages/Users/View.vue'
import UsersNew from '@/pages/Users/New.vue'
import UsersEdit from '@/pages/Users/Edit.vue'

import Flows from '@/pages/Flows.vue'
import FlowsView from '@/pages/Flows/View.vue'
import FlowsEdit from '@/pages/Flows/Edit.vue'

import Auth from '@/pages/Auth.vue'

import Route404 from '@/pages/404.vue'

const routes = [
	{
		path: '/auth/:token',
		component: Auth,
	},
	{
		path: '/',
		component: Layout,
		redirect: "/home",
		children: [
			{
				path: 'home',
				component: Dashboard
			},
			{
				path: 'pending_applications',
				component: PendingApplications,
				children: [
					{
						path: "",
						component: PendingApplicationsView
					},
					{
						path: "detail/:hash",
						component: PendingApplicationsDetail
					},
				]
			},
			{
				path: 'ongoing_applications',
				component: OngoingApplications,
				children: [
					{
						path: "",
						component: OngoingApplicationsView
					},
					{
						path: "detail/:hash",
						component: OngoingApplicationsDetail
					},
				]
			},
			{
				path: 'completed_applications',
				component: CompletedApplications,
				children: [
					{
						path: "",
						component: CompletedApplicationsView
					},
					{
						path: "detail/:hash",
						component: OngoingApplicationsDetail
					},
				]
			},
			{
				path: 'units',
				component: Units,
				children: [
					{
						path: "",
						component: UnitsView
					},
					{
						path: "new",
						component: UnitsNew
					},
					{
						path: "edit/:hash",
						component: UnitsEdit
					}
				]
			},
			{
				path: 'users',
				component: Users,
				children: [
					{
						path: "",
						component: UsersView
					},
					{
						path: "new",
						component: UsersNew
					},
					{
						path: "edit/:hash",
						component: UsersEdit
					}
				]
			},
			{
				path: 'flows',
				component: Flows,
				children: [
					{
						path: "",
						component: FlowsView
					},
					{
						path: "edit/:hash",
						component: FlowsEdit
					}
				]
			},
			
		]
	},
	{
		path: '*',
		component: Route404
	},

]

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js